import { Component, Input, OnInit } from '@angular/core';
import { OrderDetails } from 'src/app/models/order/order-details.model';

@Component({
    selector: 'order-details-banner-no-price',
    templateUrl: './no-price.component.html',
    styleUrls: ['./../banner-wrapper.component.scss', './no-price.component.scss'],
    standalone: false
})
export class NoPriceComponent implements OnInit {

  @Input() order: any;

  constructor() { }

  ngOnInit(): void {
    this.order.Total = this.order.Total.toFixed(2);
  }

}
